export default __webpack_public_path__ + "static/media/breaks.1863a3bf.png";